import BaseEntity from "./base.entity";
import { PaymentTypes } from "core/enum";
import * as R from "ramda";

const getInstallments = R.pathOr(1, ["metadata", "installments"]);
const getCashback = R.pathOr(0, ["metadata", "cashback"]);

export default class Payment extends BaseEntity {
  friendlyType() {
    if (getInstallments(this) > 1) {
      return PaymentTypes.installments;
    }

    return PaymentTypes[this.type];
  }

  getRealAmount() {
    return this.amount - getCashback(this);
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/payment.entity.js